import { lazy } from "react";

// Lazy-loaded DHEU Containers
const BlogDHEUListContainer = lazy(
  () => import("../containers/DHEU/DHEU-Blog/BlogDHEUListContainer"),
);
const CreateDHEUBlogPostContainer = lazy(
  () => import("../containers/DHEU/DHEU-Blog/CreateDHEUBlogPostContainer"),
);
const EditDHEUBlogPostContainer = lazy(
  () => import("../containers/DHEU/DHEU-Blog/EditDHEUBlogPostContainer"),
);
const CreateDHEUOrderContainer = lazy(
  () => import("../containers/DHEU/DHEU-Order/CreateDHEUOrderContainer"),
);
const CreateDHEUProductAdminContainer = lazy(
  () =>
    import("../containers/DHEU/DHEU-Product/CreateDHEUProductAdminContainer"),
);
const DuplicateProductDHEUContainer = lazy(
  () => import("../containers/DHEU/DHEU-Product/DuplicateProductDHEUContainer"),
);
const EditDHEUProductContainer = lazy(
  () => import("../containers/DHEU/DHEU-Product/EditDHEUProductContainer"),
);
const ManageDHEUProducts = lazy(
  () => import("../containers/DHEU/DHEU-Product/ManageDHEUProducts"),
);
const ADBannerDHEUListContainer = lazy(
  () => import("../containers/DHEU/DHEU-Store/ADBannerDHEUListContainer"),
);
const EditDHEUAdsContainer = lazy(
  () => import("../containers/DHEU/DHEU-Store/EditDHEUAdsContainer"),
);

export const DHEUAdminDashboardRoutes = [
  { path: "/CreateProductDHEU", component: CreateDHEUProductAdminContainer },
  { path: "/Manage-DHEU-Products", component: ManageDHEUProducts },
  { path: "/EditProductDHEU/:id", component: EditDHEUProductContainer },
  {
    path: "/DuplicateProductDHEU/:id",
    component: DuplicateProductDHEUContainer,
  },
  { path: "/CreateOrderDHEU", component: CreateDHEUOrderContainer },
  { path: "/CreateDHEUBlog", component: CreateDHEUBlogPostContainer },
  { path: "/DHEUBlogList", component: BlogDHEUListContainer },
  { path: "/EditDHEUBlog", component: EditDHEUBlogPostContainer },
  { path: "/DHEUStoreBannerList", component: ADBannerDHEUListContainer },
  { path: "/EditDHEUAds", component: EditDHEUAdsContainer },
];
